export default "__VITE_PUBLIC_ASSET__9f3e5ba3__"